export enum PARTNER_TYPES {
  FLEET_PARTNER = 'FLEET_PARTNER',
  API_PARTNER = 'API_PARTNER',
  RYD_INTERNAL = 'RYD_INTERNAL',
  ENERGY_NETWORK_PARTNER = 'ENERGY_NETWORK_PARTNER',
  MARKETING_PARTNER = 'MARKETING_PARTNER',
  INDIVIDUAL_PARTNER = 'INDIVIDUAL_PARTNER',
}

export const PARTNER_TYPE_DESCRIPTIONS: Record<PARTNER_TYPES, any> = {
  FLEET_PARTNER: {
    name: 'Fleet Partner',
    description:
      "For ryd's fleet partners. Automatically enables access to fleet management features such as driver and transaction management, and related tools.",
  },
  API_PARTNER: {
    name: 'API Partner',
    description:
      "For ryd's API integration partners. Grants access to technical resources including API documentation, demo environments, and integration tools.",
  },
  RYD_INTERNAL: {
    name: 'RYD Internal',
    description:
      "For ryd's internal staff. Enables a comprehensive set of internal tools for partner management, operations, finance, marketing, accounting, and customer support.",
  },
  ENERGY_NETWORK_PARTNER: {
    name: 'Energy Network Partner',
    description:
      "For partners in ryd's energy network. Unlocks features for managing petrol stations, products, and orders.",
  },
  MARKETING_PARTNER: {
    name: 'Marketing Partner',
    description:
      "For ryd's marketing collaborators. Provides access to features and content related to marketing campaigns, materials, and analytics.",
  },
  INDIVIDUAL_PARTNER: {
    name: 'Individual Partner',
    description:
      'For specialized partners not covered by other categories. A tailored set of features and menu items is configured by the ryd team.',
  },
};
